import { render } from "./CustomHeader.vue?vue&type=template&id=f2b8bcde&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"

import "./CustomHeader.vue?vue&type=style&index=0&id=f2b8bcde&scoped=true&lang=css"

import exportComponent from "/Users/matsunohiroshi/myact/smari/sumari-deliverybox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b8bcde"]])

export default __exports__